/** EN uses Swedish values until translated. */
import { newsEventTypeEn } from './newsTranslations'
import { millistreamSectorsTranslationsEn } from './millistreamSectorsTranslations'

export const issueTypeTooltipsEn = {
    'Rights issue': 'Show rights issues',
    IPO: 'Show IPO',
    'Directed issue': 'Show directed issues',
    'Non-cash issue': 'Show non-cash issues',
    Warrant: 'Show warrants',
    Convertible: 'Show convertibles',
}

export const entitiesEn = {
    issue: {
        plural: 'Share issues',
        fields: {
            id: 'Id',
            shareId: 'Share',
            recordDate: 'Record date',
            incRightsDate: 'Date incl rights',
            exRightsDate: 'Date excl rights',
            rightsStartDate: 'First day of rights',
            rightsEndDate: 'Last day of rights',
            subStartDate: 'Subscription period start',
            subEndDate: 'Subscription period end',
            ipoTradingDate: 'First trading date',
            outstandingShares: 'Outstanding shares',
            offeredUnits: 'Offered units',
            rightsRequired: 'Rights required',
            unitsReceived: 'Units received',
            sharesInUnit: 'Shares per unit',
            unitSubPrice: 'Subscription price per unit',
            approxCommitment: 'Commitment (approx)',
            approxGuarantor: 'Guaranteed (approx)',
            overAllotmentSize: 'Overallotment size',
            overAllotmentAllocation: 'Overallotment allocation',
            internalComment: 'Internal comment',
            externalComment: 'External comment',
            unitSubTotal: 'Units subscribed',
            unitSubWithRights: 'Units subscribed with rights',
            unitSubWithoutRights: 'Units subscribed without rights',
            unitSubGuarantor: 'Units subscribed by guarantors',
            unitGuaranteeFee: 'Units received as guarantor fee',
            generalMeetingDate: 'General meeting date',
            isinRights: 'ISIN (rights)',
            isinUnits: 'ISIN (units)',
            cancelled: 'Cancelled',
            approxTotalCommitment: 'Total commitment (approx)',
            sharesRequired: 'Shares required',
            rightsReceived: 'Rights received',
            unitPctSubWithRights: 'Units subscribed with rights (%)',
            unitPctSubWithoutRights: 'Units subscribed without rights (%)',
            unitPctSubGuarantor: 'Units subscribed by guarantors (%)',
        },
    },
    issueType: {
        earnout: 'Earnout',
        specialUnitIssue: 'Special unit issue',
        tooltips: {
            'Rights issue': 'Show rights issues',
            IPO: 'Show IPO',
            'Directed issue': 'Show directed issues',
            'Non-cash issue': 'Show non-cash issues',
            Warrant: 'Show warrants',
            Convertible: 'Show convertibles',
        },
        values: {
            'ABB Directed issue': 'Directed issue (ABB)',
            'Directed issue': 'Directed issue',
            'Guarantor fee issue': 'Guarantor fee issue',
            IPO: 'IPO',
            'Non-cash issue': 'Non-cash issue',
            'Rights issue': 'Rights issue',
            Warrant: 'Warrants',
            Convertible: 'Convertibles',
            reverseTakeover: 'Reverse takeover',
        },
    },
    warrant: {
        singular: 'Warrant',
        plural: 'Warrants',
        fields: {
            priceMin: 'Min sub price',
            priceMax: 'Max sub price',
            sharesSubscribed: 'Subscribed shares',
            internalComment: 'Internal comment',
            externalComment: 'Comment',
            warrantsPerUnit: 'Warrants per unit',
            warrantSubPrice: 'Subscription price',
        },
    },
    company: {
        singular: 'Company',
        plural: 'Company',
        fields: {
            name: 'Name',
            isin: 'ISIN',
            industry: 'Industry',
        },
    },
    news: {
        eventType: newsEventTypeEn,
        fields: {
            newsType: 'News type',
        },
    },
    investor: {
        plural: 'Investor',
    },
    convertible: {
        plural: 'Convertibles',
        convertibleLoan: 'Convertible loan',
        fields: {
            conversion: 'Conversion',
            repayment: 'Repaymeny',
            offset: 'Off-set',
            new_loan: 'New debt',
            write_off: 'Write-off',
        },
    },
    common: {
        subscriptionRate: 'Subscription rate',
        totalCommitmentRate: 'Secured level',
        issueType: 'Type of issue',
    },
    tableHeaders: {
        country: 'Country',
        name: 'Name',
        sector: 'Sector',
        marketList: 'List',
        marketCap: 'Market Cap',
        latestIssue: 'Latest issue',
        latestIssueDescription:
            'The date shows when the subscription period started for a rights issue. For other issues, it is the date when the issue was first published.',
        issue: 'Issue',
        preMoney: 'Pre-money',
        subscriptionPrice: 'Sub price (per share)',
        closePriceYesterday: 'Share price (yesterday)',
        marketCapYesterday: 'Market cap (yesterday)',
        legalAdvisors: 'Legal advisors',
        issuingAgents: 'Issuing agents',
        discount10dVwap: 'Discount (10d VWAP)',
        terpDiscount10dVwap: 'TERP discount (10d VWAP)',
        dilutionMax: 'Dilution (max)',
        dilutionActual: 'Dilution (actual)',
        feeLevel1: 'Guarantor fee',
        warrants: 'Warrants',
        noncashConsideration: 'Non-cash consideration',
        issueType: 'Type',
        share: 'Share',
        tags: 'Tags',
        status: 'Status',
        date: 'Date',
        dateDescription:
            'The date shows the last day of the subscription period for completed rights issues and the first trading day for completed IPOs, otherwise the full subscription period. For other issues, it is the date when the issue was first published.',
        issueSector: 'Sector',
        offeredSize: 'Amount',
        subscribedSize: 'Subscribed amount',
        financialAdvisors: 'Fin. advisors',
        totalCommitment: 'Commitment rate',
        outcome: 'Outcome',
        priceChange: 'Price change',
        updatedAt: 'Updated',
        selectAdvisorTypeDescription: 'Select type of advisor to show',
        selectPriceChangePeriodDescription: 'Select price change period since issue',
        postIssueMax: 'Max',
        postIssue3m: '3 months',
        postIssue6m: '6 months',
        postIssue12m: '12 months',
        loanAmount: 'Loan amount',
        maturityDate: 'Maturity date',
        publicationDate: 'Publication date',
        subStartDate: 'First subscription day',
        subEndDate: 'Last subscription day',
        warrantSubPrice: 'Subscription price',
        closePrice: 'Current share price',
        warrantAmount: 'Amount',
        countSharesSubscribed: 'Subscribed warrants',
        subscribedAmount: 'Subscribed amount',
        unlisted: 'Unlisted',
    },
    millistreamSectors: millistreamSectorsTranslationsEn,
}
